<!-- 工作动态 -->
<template>
  <div class="cm_work_container">
    <!-- 标题 -->
    <div class="cm_work_title">
      <h3>{{data.name}}</h3>
      <router-link :to="{path:'/list',query:{urlData:JSON.stringify(data)}}" v-cloak>MORE+</router-link>
    </div>
    <!-- 内容 -->
    <div v-loading="loading" style="min-height:280px">
      <ul class="cm_work_content">
        <li v-for="item in dataList" :key="item.NEWS_ID" @click="toDetail(item.NEWS_ID,data)">
          <!-- 日期 -->
          <div class="cm_work_content_date">
            <span class="cm_work_date_top" >{{cutDate(item.PUBLISH_DATE)[0]}}</span>
            <span class="cm_work_date_bottom">{{cutDate(item.PUBLISH_DATE)[1]}}</span>
          </div>
          <!-- 内容标题 -->
          <div class="cm_work_content_title">
            <h3>{{item.TITLE}}</h3>
            <div class="cm_work_content_notes">
              <!--<span>{{item.SOURCE}}</span>-->
              <!-- <span>浏览量：1</span> -->
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props:["data"],
  data() {
    //这里存放数据
    return {
      url:this.data.url,
      dataList:[],
      loading:true
    };
  },
  //监听属性 类似于data概念
  computed: {
    cutDate:function(date){
      return (date)=>[date.substring(0,7),date.substring(8)]
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    httpPost() {
      this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.data.data 
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.pdList
          this.loading = false
        }
          
      });
    },
    toDetail(ID,data){
      this.$router.push({path:'/detail/'+ID,query: {parentData:JSON.stringify(data)}})
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.httpPost()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
};
</script>
<style scoped>
.cm_work_container {
  width: 572px;
  height: 418px;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
}
.cm_work_title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 75px;
  padding: 0 20px;
}
.cm_work_title > h3 {
  font-size: 24px;
  font-weight: 500;
  color: rgba(67, 121, 211, 1);
  line-height: 33px;
}
.cm_work_content{
  padding: 0 20px;
  overflow: hidden;
}
.cm_work_content>li{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  cursor: pointer;
}
.cm_work_content_date{
  box-shadow:0px 2px 4px 0px rgba(0,0,0,0.14);
  border-radius:3px;
  width: 70px;
  height: 70px;
}
.cm_work_date_top{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:14px;
  font-weight:400;
  color:rgba(255,255,255,1);
  background: #4379D3;
  height: 30%;
}

.cm_work_date_bottom{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight:600;
  color:rgba(86,86,86,1);
  background: #fff;
  height: 70%;
}
.cm_work_content_title{
  width: 82%;
  height: 70px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.cm_work_content_title>h3{
  width: 100%;
  font-size:18px;
  font-weight:600;
  color:rgba(67,121,211,1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cm_work_content_notes>span{
  font-size:14px;
  color:rgba(164,164,164,1);
  margin-right: 10px;
  margin-top: 13px;
  }

</style>